import React from "react";
import Image from "next/image";
import { LoginImg } from "../assets";

type MainLoginProps = {
    onTeacherLoginClick?: () => void;
};

export default function MainLogin({ onTeacherLoginClick }: MainLoginProps) {
    const handleOpenStudentLogin = () => {
        window.open(
            "https://login.pilaproject.org/?redirect_uri=https%3A%2F%2Fauth.knowlearning.systems%2F&response_type=code&nonce=y0dtq3b1gk&state=947opnr33ab&origin=https%3A%2F%2Fthailand.pilaproject.org%2F",
            "_blank",
            "noopener,noreferrer"
        );
    };

    const handleOpenThaiPilaPlatform = () => {
        window.open(
            "https://thailand.pilaproject.org/teacher/classes",
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#F4F3ED] p-3 sm:p-4 md:p-6 lg:p-0">
            <div className="flex w-full max-w-xl flex-col overflow-hidden overflow-y-auto rounded-2xl bg-white shadow-[0_8px_30px_rgb(0,0,0,0.08)] min-h-0 max-h-[calc(100dvh-1.5rem)] md:max-w-2xl lg:max-h-none lg:max-w-4xl lg:min-h-[700px] lg:flex-row lg:py-0">
                <div className="relative hidden w-full lg:block lg:w-1/2">
                    <Image
                        src={LoginImg}
                        alt="THAI PILA Illustration"
                        fill
                        className="object-cover"
                        priority
                    />
                </div>

                <div className="flex w-full flex-col items-center justify-center px-5 py-6 sm:px-6 sm:py-7 md:px-8 md:py-8 lg:w-1/2 lg:p-12">
                    <h1 className="mb-4 text-xl font-bold text-gray-900 sm:mb-5 sm:text-2xl lg:mb-6">
                        เข้าสู่ระบบ
                    </h1>

                    <div className="mb-6 text-center sm:mb-7 md:mb-8 lg:mb-8">
                        <h2 className="mb-1 text-lg font-bold text-[#007FC3] sm:text-xl lg:text-2xl">
                            ยินดีต้อนรับสู่ THAI PILA!
                        </h2>
                        <p className="text-lg font-bold text-[#007FC3] sm:text-xl lg:text-2xl">
                            บอกให้เรารู้ว่าคุณเป็นใคร?
                        </p>
                    </div>

                    <div className="flex w-full max-w-md flex-col gap-4 sm:max-w-90 sm:gap-5 lg:gap-6">
                        <button
                            type="button"
                            onClick={handleOpenStudentLogin}
                            className="w-full cursor-pointer rounded-md bg-[#FCE654] px-5 py-3 text-lg font-semibold text-gray-900 shadow-sm transition-colors hover:bg-[#F5DF4D] sm:px-6 sm:py-3.5 sm:text-xl lg:py-4 lg:text-xl"
                        >
                            นักเรียน
                        </button>

                        <button
                            type="button"
                            onClick={handleOpenThaiPilaPlatform}
                            className="w-full cursor-pointer rounded-md bg-[#FCE654] px-5 py-3 text-lg font-semibold text-gray-900 shadow-sm transition-colors hover:bg-[#F5DF4D] sm:px-6 sm:py-3.5 sm:text-xl lg:py-4 lg:text-xl"
                        >
                            ครู/อาจารย์
                        </button>

                        <button
                            type="button"
                            onClick={onTeacherLoginClick}
                            className="w-full cursor-pointer rounded-md bg-[#FCE654] px-5 py-3 text-lg font-semibold text-gray-900 shadow-sm transition-colors hover:bg-[#F5DF4D] sm:px-6 sm:py-3.5 sm:text-xl lg:py-4 lg:text-xl"
                        >
                            แพลตฟอร์มกิจกรรม THAI PILA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
